import { useEffect } from "react";

export const PageMeta = ({ title, description }) => {
    useEffect(() => {
        document.title = title;
        const el = document.querySelector('meta[name="description"]');
        if (el && description) el.setAttribute("content", description);
    }, [title, description]);
    return null;
};
